"use client";

import classNames from "classnames";
import {
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
} from "@vetty/icons";
import {
  DayPicker,
  type CustomComponents,
  type DayPickerProps,
} from "react-day-picker";
import "react-day-picker/style.css";
import styles from "./Calendar.module.scss";

type ChevronComponentProps = {
  className?: string;
  size?: number;
  disabled?: boolean;
  orientation?: "up" | "down" | "left" | "right";
};

function CalendarChevron({
  className,
  size = 20,
  disabled,
  orientation = "left",
}: ChevronComponentProps) {
  const iconStyle = {
    width: size,
    height: size,
    opacity: disabled ? 0.5 : 1,
    fill: "none",
    color: "var(--color-text)",
  } as const;

  switch (orientation) {
    case "right":
      return (
        <ChevronRightIcon
          className={className}
          style={iconStyle}
          aria-hidden
        />
      );
    case "down":
      return (
        <ChevronDownIcon
          className={className}
          style={iconStyle}
          aria-hidden
        />
      );
    case "up":
      return (
        <ChevronUpIcon className={className} style={iconStyle} aria-hidden />
      );
    case "left":
    default:
      return (
        <ChevronLeftIcon
          className={className}
          style={iconStyle}
          aria-hidden
        />
      );
  }
}

const defaultComponents: Partial<CustomComponents> = {
  Chevron: CalendarChevron,
};

export type CalendarProps = DayPickerProps;

export function Calendar({
  className,
  components,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      {...props}
      className={classNames(styles["root"], className)}
      components={{
        ...defaultComponents,
        ...components,
      }}
    />
  );
}
